/* eslint-disable react/self-closing-comp */
/* eslint-disable react/react-in-jsx-scope */

import React, { memo } from 'react';
import logoLoading from '../../../Res/logo-loading.gif';

const CustomSpinner = memo(() => {
  return (
    <div>
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
    </div>
  );
});

export default CustomSpinner;
